/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AddWorksheetModal_classroom = {
    readonly id: string;
    readonly classroomWorksheets: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly worksheet: {
                    readonly id: string;
                };
            } | null;
        } | null> | null;
    };
    readonly " $refType": "AddWorksheetModal_classroom";
};
export type AddWorksheetModal_classroom$data = AddWorksheetModal_classroom;
export type AddWorksheetModal_classroom$key = {
    readonly " $data"?: AddWorksheetModal_classroom$data;
    readonly " $fragmentRefs": FragmentRefs<"AddWorksheetModal_classroom">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "AddWorksheetModal_classroom",
  "type": "Classroom",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "classroomWorksheets"
        ]
      }
    ]
  },
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": "classroomWorksheets",
      "name": "__AddWorksheetModal_classroomWorksheets_connection",
      "storageKey": null,
      "args": null,
      "concreteType": "ClassroomWorksheetConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ClassroomWorksheetEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "ClassroomWorksheet",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "worksheet",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Worksheet",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '0caf1b6f1d40a865be9a73e417df37ad';
export default node;
